<template>
  <div>
    <div v-if="!Boolean(localTrainings.length)" class="non-trainings">
      {{ $t('src/components/coursedatatable.noSessions') }}
    </div>
    <div v-else class="scroll-table scroll-table-min">
      <table class="table table-list-training min">
        <thead>
          <tr>
            <th>{{ $t('general.date') }}</th>
            <th>{{ $t('general.type') }}</th>
            <template v-if="!isFreeActiveMeasurement">
              <th>{{ $t('src/components/coursedatatable.8698') }}</th>
              <th>{{ $t('sessionsInfo.averageHeartRate') }}</th>
              <th>{{ $t('general.duration') }}</th>
              <th>{{ $t('src/components/coursedatatable.3907') }}</th>
            </template>
            <th>{{ $t('src/components/training/trainingresults6mwt.saturation') }}</th>
            <th>{{ $t('src/components/chat.pressure') }}</th>
            <template v-if="isFreeActiveMeasurement || isAllActiveMeasurements">
              <th>{{ $t('src/components/chat.glucose') }}</th>
            </template>
          </tr>
        </thead>
        <tbody>
          <course-data-table-row
            v-for="train in localTrainings"
            :key="train.id"
            :training="train"
            :activeMeasurementType="activeMeasurementType"
          ></course-data-table-row>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import('@/styles/components/trainings-list.less')
import { measurementType, timePeriods, messageTypes } from '@/main.config'

export default {
  name: 'CourseDataTable',
  components: {
    CourseDataTableRow: () => import('@/components/table-rows/CourseDataTableRow.vue')
  },
  props: {
    trainings: {
      type: Array,
      required: true
    },
    trainings6mwt: {
      type: Array,
      required: true
    },
    isStandart: {
      type: Boolean,
      required: true,
      default: true
    },
    allDoneTrainings: {
      type: Array,
      required: true
    },
    freeMeasurementsData: {
      type: Array,
      required: false
    },
    activeMeasurementType: {
      type: Number,
      required: true
    },
    activeTimeData: {
      type: Number,
      required: true
    },
    selectedDate: {
      type: Date,
      required: false
    }
  },
  data: () => ({
    localTrainings: null
  }),
  watch: {
    activeMeasurementType() {
      this.setLocalTraining()
    },
    activeTimeData() {
      this.setLocalTraining()
    },
    selectedDate() {
      this.setLocalTraining()
    }
  },
  created() {
    this.setLocalTraining()
  },
  computed: {
    isFreeActiveMeasurement() {
      return this.activeMeasurementType === measurementType.free
    },
    isAllActiveMeasurements() {
      return this.activeMeasurementType === measurementType.all
    }
  },
  methods: {
    setLocalTraining() {
      switch (this.activeMeasurementType) {
        case measurementType.standart:
          this.localTrainings = this.getDataWithTimeFilter(this.trainings)
          break
        case measurementType.mwt6:
          this.localTrainings = this.getDataWithTimeFilter(this.trainings6mwt)
          break
        case measurementType.free:
          this.localTrainings = this.getDataWithTimeFilter(
            this.getCombinedMeasurements(this.freeMeasurementsData)
          )
          break
        case measurementType.all:
          this.localTrainings = this.getAllMeasurements()
      }
    },
    getCombinedMeasurements(freeMeasurementsData) {
      freeMeasurementsData.sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt))

      const result = []
      let currentGroup = null

      freeMeasurementsData.forEach(item => {
        const itemDate = new Date(item.createdAt)
        if (!currentGroup || itemDate - currentGroup.date_start > 900000) {
          if (currentGroup) {
            result.push(currentGroup)
          }
          currentGroup = {
            date_start: itemDate,
            saturation: '',
            pressure: '',
            glucose: ''
          }
        }
        if (item.type === messageTypes.saturation) {
          currentGroup.saturation = item.content
        } else if (item.type === messageTypes.pressure) {
          currentGroup.pressure = item.content
        } else if (item.type === messageTypes.glucose) {
          currentGroup.glucose = item.content
        }
      })
      if (currentGroup) {
        result.push(currentGroup)
      }

      return result
    },
    getAllMeasurements() {
      const combinedArray = [
        ...this.getDataWithTimeFilter(this.getCombinedMeasurements(this.freeMeasurementsData)),
        ...this.getDataWithTimeFilter(this.allDoneTrainings)
      ]
      combinedArray.sort((a, b) => new Date(a.date_start) - new Date(b.date_start))
      return combinedArray
    },
    getDataWithTimeFilter(array) {
      const currentDate = new Date()
      let timeDataStartDate
      let timeDataEndDate = currentDate
      switch (this.activeTimeData) {
        case timePeriods.allTime:
          return array
        case timePeriods.oneDay:
          timeDataStartDate = this.selectedDate
          timeDataEndDate = new Date(
            this.selectedDate.getFullYear(),
            this.selectedDate.getMonth(),
            this.selectedDate.getDate() + 1
          )
          break
        case timePeriods.oneWeek:
          timeDataStartDate = new Date(
            currentDate.getFullYear(),
            currentDate.getMonth(),
            currentDate.getDate() - 7
          )
          break
        case timePeriods.oneMonth:
          timeDataStartDate = new Date(
            currentDate.getFullYear(),
            currentDate.getMonth(),
            currentDate.getDate() - 31
          )
          break
        case timePeriods.threeMonths:
          timeDataStartDate = new Date(
            currentDate.getFullYear(),
            currentDate.getMonth(),
            currentDate.getDate() - 92
          )
          break
      }
      const filteredArray = array.filter(item => {
        const itemDate = new Date(item.date_start)

        return itemDate >= timeDataStartDate && itemDate <= timeDataEndDate
      })

      return filteredArray
    },
    timeDifference(obj1, obj2) {
      const time1 = new Date(obj1.createdAt).getTime()
      const time2 = new Date(obj2.createdAt).getTime()
      return Math.abs(time1 - time2) < 30000
    }
  }
}
</script>
